<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
         <!-- <div class="modal__logo-title">Seguro Desk</div> -->
      </div>

      <div class="modal__main-icon modal__main-icon--team"></div>

      <div class="modal__close" @click="closeModal()"></div>

      <div class="form"> 
        <form class="add__form">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading"/>
            <div v-else class="add__content">
              <transition name="fade" mode="out-in">
                <div class="details" key="0">


                  <div class="form__field">
                    <input
                        type="text"
                        class="input input--default"
                        :placeholder="$t('addTeamModal.teamNamePlaceholder')"
                        v-model="name"
                        :class="{
                        'input--error': nameHasError,
                      }"
                    />
                    <div class="form__error" v-if="nameHasError">
                      {{ nameErrorPlaceholder }}
                    </div> 
                  </div>

                  <div class="form__field">
                    <input
                        type="text"
                        class="input input--default"
                        placeholder="FINMA Nr."
                        v-model="finma_nr"
                    />
                  </div>

                  <div class="form__field" v-if="!teamIsEdit">  
                    <VSelect
                        :options="teams"
                        :reduce="(team) => team.id"
                        :placeholder="$t('addTeamModal.teamId')"
                        label="name"
                        v-model="team.id"
                        class="select select--default" 
                    /> 

                  </div>

                  <div class="form__field">
                    <VSelect
                        :options="owners"
                        :reduce="(owner) => owner.id"
                        :placeholder="$t('addTeamModal.ownerPlaceholder')"
                        :getOptionLabel="(owner) => `${owner.first_name} ${owner.last_name}`"
                        v-model="owner.id"
                        class="select select--default"
                        :class="{ 'select--error': ownerHasError }"
                    />
                    <div class="form__error" v-if="ownerHasError">
                      {{ $t(`addTeamModal.${"ownerErrorMsg"}`) }}
                    </div>

                  </div>

                  <div class="form__field">
                    <MultiSelectDropdown
                        v-if="hasMandateTypes"
                        :items="mandateTypes"
                        placeholder="Mandate Types"
                        label="name"
                        :reduce="(mandate) => mandate.id"
                        :selected="mandate_type_ids"
                        @input="onMandateTypesChange"
                    />
                    <div v-else class="input input--default input--readonly">
                      <span v-if="teamIsEdit && teamToEdit.mandate_types && teamToEdit.mandate_types.length">
                        {{ teamToEdit.mandate_types.map(mt => mt.name).join(', ') }}
                      </span>
                      <span v-else style="color: #999;">No mandate types available</span>
                    </div>
                  </div>

                  <div class="form__row">
                    <div class="form__field form__field--double">
                      <input
                          type="text"
                          class="input input--default"
                          placeholder="Strasse *"
                          v-model="street"
                          :class="{ 'input--error': streetHasError }"
                      />
                    </div>
                    <div
                        class="form__field form__field--double form__field--nr"
                    >
                      <input
                          type="text"
                          class="input input--default"
                          placeholder="Nr."
                          v-model="number"
                      />
                    </div>
                  </div>

                  <div class="form__row">
                    <div class="form__field form__field--double">
                      <input
                          type="text"
                          class="input input--default"
                          placeholder="PLZ *"
                          v-model="zip"
                          :class="{ 'input--error': zipHasError }"
                      />

                      <div class="form__error" v-if="zipHasError">
                        {{ zipCodePlaceholder }}
                      </div>
                    </div>
                    <div class="form__field form__field--double">
                      <VSelect
                          v-if="zipCodeData.length > 1"
                          :options="zipCodeData"
                          :reduce="(city) => city.city"
                          placeholder="ORT *"
                          label="city"
                          v-model="city"
                          class="select select--default"
                          :class="{
                          'select--error': cityHasError,
                        }"
                      />

                      <div
                          v-else-if="zipCodeData.length"
                          class="input input--default input--readonly"
                          :class="{ 'input--error': cityHasError }"
                      >
                        {{ city }}
                      </div>

                      <input
                          v-else-if="!zipCodeData.length"
                          type="text"
                          class="input input--default"
                          placeholder="ORT *"
                          v-model="city"
                          :class="{ 'input--error': cityHasError }"
                      />

                      <div class="form__error" v-if="cityHasError">
                        {{ $t(`addTeamModal.${"cityErrorMsg"}`) }}
                      </div>
                    </div>
                  </div> 

                  <div class="logo">
                    <div class="add__avatar">
                      <img
                          v-if="userImage"
                          :src="userImage"
                          alt=""
                          ref="userImageElement"
                      />
                      <div v-else class="add__avatar-empty">
                        <img
                            class="add__avatar-empty"
                            src="../assets/icons/default/Bold 2px-person-white.svg"
                            alt=""
                        />
                      </div>
                    </div>
                    <div class="add__upload-text">
                      Upload your Image / Logo
                    </div>
                    <div class="add__upload-wrapper">
                      <button
                          type="button"
                          class="button button--default button--upload"
                          @click="uploadFile.click()"
                      >
                        Upload Image
                      </button>
                      <input
                          ref="uploadFile"
                          type="file"
                          class="add__upload"
                          @change="uploadImage($event)"
                      />
                    </div>
                  </div>
                </div> 
              </transition> 
            </div>
          </transition>

        </form>
      </div>
      <div
          v-if="isRequesting"
          class="modal__button modal__button--submit button button--default button--loading"
      ></div>
      <div v-else>
        <button
          v-if="loggedUser.is_super_admin"
          type="button"
          class="modal__button modal__button--submit button button--default"
          @click="createTeam()"
        >
          <span>{{ $t(`addTeamModal.${"saveBtn"}`) }}</span> 
        </button>
        </div> 
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Loading from "@/partials/Loading";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";
import parseFieldErrors from "@/helpers/parseFieldErrors";
import api from "@/api";
import { useI18n } from 'vue-i18n';   

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();
defineOptions({
  name: "AddTeamModal"
});

const store = useStore();
const route = useRoute();

// Template Reference Mapping
const uploadFile = ref(null);
const userImageElement = ref(null);

// Reactive Components / Input Fields
const name = ref("");
const finma_nr = ref("");
const mandate_type_ids = ref([]);
const mandateTypesList = ref([]);
const street = ref("");
const number = ref("");
const zip = ref("");
const city = ref("");
const id = ref("");
const file = ref("");
const userImage = ref("");

const owner = reactive({
  id: "",
  name: ""
});

const team = reactive({
  id: "",
  name: ""
});

// UI Logic Form Errors / State management
const formLoading = ref(false);
const isRequesting = ref(false);
const nameHasError = ref(false);
const ownerHasError = ref(false);
const streetHasError = ref(false);
const zipHasError = ref(false);
const cityHasError = ref(false);

const nameErrorPlaceholder = ref("");
const zipCodePlaceholder = ref("");
const specificErrors = ref([]);

// Placeholders for isolated state handling referenced during input hooks
const privateAddress = reactive([{ city: "" }]);

// Computed properties mapped from Vuex Store
const teamForms = computed(() => store.getters.teamForms);
const teamIsEdit = computed(() => store.getters.teamIsEdit);
const teamToEdit = computed(() => store.getters.teamToEdit);
const loggedUser = computed(() => store.getters.loggedUser);

const owners = computed(() => teamForms.value?.owners || []);
const teams = computed(() => loggedUser.value?.teams || []);

const mandateTypes = computed(() => {
  if (mandateTypesList.value && mandateTypesList.value.length > 0) {
    return mandateTypesList.value;
  }
  if (teamIsEdit.value && teamToEdit.value?.mandate_types) {
    return teamToEdit.value.mandate_types;
  }
  return [];
});

const hasMandateTypes = computed(() => {
  return mandateTypesList.value && mandateTypesList.value.length > 0;
});

const zipCodeData = computed({
  get() {
    return store.state.zipCodes.zipCodeData || [];
  },
  set(value) {
    store.commit("setZipCodeData", value);
  },
});

// Structural Input Field Watchers
watch(() => owner.id, (value) => {
  ownerHasError.value = !value;
});

watch(name, (value) => {
  nameHasError.value = !value;
});

watch(zip, async (newZip) => {
  if (newZip) {
    zipHasError.value = false;
    zipCodePlaceholder.value = "";

    if (Number(newZip) >= 1000 && Number(newZip) <= 9999) {
      await loadCities(newZip);
    } else {
      zipCodeData.value = [];
      privateAddress[0].city = "";
      zipHasError.value = true;
      zipCodePlaceholder.value = "Invalid zip code";
    }
  } else {
    privateAddress[0].city = "";
    zipHasError.value = true;
    zipCodePlaceholder.value = "Please enter a zip code";
  }
});

watch(city, (value) => {
  cityHasError.value = !value;
});

watch(street, (value) => {
  streetHasError.value = !value;
});

// Structural Methods Block
const onMandateTypesChange = (selectedIds) => {
  mandate_type_ids.value = selectedIds;
};

const fetchMandateTypes = async () => {
  try {
    const response = await api({ requiresAuth: true }).get("/v1/mandate-types");
    if (response.data && response.data.data) {
      mandateTypesList.value = response.data.data;
    } else {
      mandateTypesList.value = [];
    }
  } catch (err) {
    console.error("Error fetching mandate types:", err);
    mandateTypesList.value = [];
  }
};

const closeModal = () => {
  store.commit("setShowAddTeamModal", false);
  store.commit("setTeamIsEdit", false);
  zipCodeData.value = [];
};

const validateForm = () => {
  if (!name.value) {
    nameHasError.value = true;
  }
  if (!owner.id) {
    ownerHasError.value = true;
  } 
  if (!zip.value) {
    zipHasError.value = true;
    zipCodePlaceholder.value = "Please enter a zip code";
  }
  if (!city.value) {
    cityHasError.value = true;
  }
  if (!street.value) {
    streetHasError.value = true;
  }
};

const loadCities = async (value) => {
  await store.dispatch("getZipCodeData", value);
  zip.value = value;
  if (zipCodeData.value && zipCodeData.value.length > 0) {
    city.value = zipCodeData.value[0].city;
  }
};

const createTeam = async () => {
  validateForm();
  if (!nameHasError.value && !ownerHasError.value && !zipHasError.value && !cityHasError.value && !streetHasError.value) {
    isRequesting.value = true; 
    try {
      const teamData = {
        fromTeamId: team.id,
        owner: owner,
        name: name.value,
        finma_nr: finma_nr.value,
        id: id.value,
        zip: zip.value,
        street: street.value,
        city: city.value,
        number: number.value,
        file: file.value
      };

      if (hasMandateTypes.value) {
        teamData.mandate_type_ids = mandate_type_ids.value;
      }

      if (teamIsEdit.value) {
        if (route.name === "Teams" && file.value) {
          await store.dispatch("addTeamPhoto", {
            teamId: teamToEdit.value.id,
            file: file.value,
          });
        }
        
        const updateData = {
          teamId: id.value, 
          owner: owner,
          name: name.value,
          finma_nr: finma_nr.value,
          zip: zip.value,
          street: street.value,
          city: city.value,
          number: number.value,
          file: file.value
        };

        if (hasMandateTypes.value) {
          updateData.mandate_type_ids = mandate_type_ids.value || [];
        }
        await store.dispatch("updateTeam", updateData);
        store.commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.teamUpdatedSuccessfully"),
          duration: 3000
        });
      } else {
        await store.dispatch("createTeam", teamData);
        store.commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.teamAddedSuccessfully"),
          duration: 3000
        });
      }
      closeModal();
    } catch (err) {
      if (err.response?.data?.errors) {
        const { errors } = err.response.data;
        specificErrors.value = parseFieldErrors(errors);
      }
      isRequesting.value = false;
    }
  }
};

const uploadImage = (event) => {
  file.value = event.target.files[0];
  userImage.value = URL.createObjectURL(file.value);
};

// Application Execution Lifecycles
onMounted(async () => {
  formLoading.value = true;

  if (loggedUser.value && !loggedUser.value.is_super_admin) {
    closeModal();
  } else {
    await store.dispatch("getTeamForms");
    await fetchMandateTypes();

    if (teamIsEdit.value && teamToEdit.value) {
      name.value = teamToEdit.value.name;
      finma_nr.value = teamToEdit.value.finma_nr || "";
      mandate_type_ids.value = teamToEdit.value.mandate_types ? teamToEdit.value.mandate_types.map(mt => mt.id) : [];
      owner.id = teamToEdit.value.owner?.id || "";
      id.value = teamToEdit.value.id;
      street.value = teamToEdit.value.street;
      number.value = teamToEdit.value.number;
      zip.value = teamToEdit.value.zip;
      city.value = teamToEdit.value.city;
      userImage.value = teamToEdit.value.photo ? teamToEdit.value.photo.thumbnail : "";
    }
  }

  formLoading.value = false;
});
</script>

<style scoped>
.modal__panel{
  height: 650px;
}
</style>